import axios from 'axios';
import { endpoints } from '../utils/constants';
import { initializeSessionId } from '../utils/DataService';

export const sessionId = initializeSessionId();

// Updated singleSignInUrl without callbackurl parameter
export const singleSignInUrl = `${endpoints.itemService}/${endpoints.pathPrefix}saml/login?returnUrl=${encodeURIComponent(`${endpoints.itemService}`)}&sessionId=${sessionId}`;
  
export const getUserToken = async (idToken: string) => {
    const response = await axios({
        url: endpoints.itemService + '/' + endpoints.pathPrefix + 'auth',
        method: "GET", headers: {
            "Content-Type": "application/json",
            IdToken: idToken,
            sessionId: sessionId
        }
    });
    return response;
}